/**
 * Test format of sting values
 */
const Tester = {

    /**
     * Begins with "+"" sign
     * Has at least 10 digits
     * 
     * @param string value 
     * @returns bool
     */
    testPhone(value){

        if( typeof value !== 'string' && !(value instanceof String) ){
            return false;
        }

        if( !value.startsWith('+') ){
            return false;
        }

        let digits = value.substring(1).replaceAll(' ', '');

        if(digits.length < 10 || digits.length > 15){
            return false;
        }

        if( !(/^\d+$/.test(digits)) ){
            return false;
        }

        return true;
    },

    /**
     * At least one uppercase letter and one special character
     * 8 characters long
     * 
     * @param string value 
     * @returns bool
     */
    testPassword(value){
        let regExp = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})')
        return regExp.test(value);
    },

    /**
     * Check email format
     * 
     * @param string value 
     * @returns bool
     */
    testEmail(value){
        return String(value)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    },

    /**
     * 14 digits
     * 
     * @param string value 
     * @returns bool
     */
    testSiret(value){
        let regExp = new RegExp('([0-9]{14})')
        return regExp.test(value);
    },


}

export default Tester;